import { css } from "@filadd/phi-plus-styled-system/css";

import { useStudyProgramsByCourse } from "hooks/courses-new/study-program";

import { StudyProgramCard } from "./StudyProgramCard";

interface Props {
  courseSlug: string;
}

export const StudyProgramList = ({ courseSlug }: Props) => {
  const {
    data: studyPrograms,
    isLoading,
    isError,
    error,
  } = useStudyProgramsByCourse({
    params: {
      field: "slug",
      value: courseSlug,
      expands: ["progress", "stats"],
    },
  });

  if (isLoading) {
    return <p>Loading...</p>;
  }

  if (isError) {
    return (
      <p>Error: Failed to fetch study programs by course: ${error?.message}</p>
    );
  }

  if (!studyPrograms) {
    return <p>No study programs found for this course</p>;
  }

  return (
    <div
      className={css({
        display: "grid",
        gap: 4,
        gridTemplateColumns: {
          base: "1fr",
          sm: "1fr 1fr",
        },
      })}
    >
      {studyPrograms.map((studyProgram) => (
        <StudyProgramCard
          key={studyProgram.id}
          courseSlug={courseSlug}
          {...studyProgram}
        />
      ))}
    </div>
  );
};
